<!--
 * @Description: 
 * @Author: WangYuhan
 * @Date: 2022-12-09 17:54:05
 * @LastEditTime: 2023-12-12 11:03:46
 * @LastEditors: WangYuhan
-->
<template>
  <el-cascader
    class="inline-input"
    :value="value"
    :size="size"
    :placeholder="placeholder"
    :options="options"
    :clearable="clearable"
    @clear="handclear"
    :props="{ value: 'label', label: 'label', children: 'children', checkStrictly: true }"
    @change="change"
  />
</template>

<script>
import city from '@/utils/city.js';

export default {
  name: 'nf-cascader',
  props: {
    storeModelName: {
      type: String,
      required: true,
      default: '',
    },
    formData: {
      type: Object,
      required: true,
      default: () => {},
    },
    index: {
      type: Number,
      default: 0,
    },
    value: {
      type: Array,
      default: () => {},
    },
    type: {
      type: String,
      default: '',
    },
    format: {
      type: String,
      default: '',
    },
    valueFormat: {
      type: String,
      default: '',
    },
    // 输入框尺寸  默认 small  medium/small/mini
    size: {
      type: String,
      default: 'mini',
    },
    // 是否清空选项 默认false
    clearable: {
      type: Boolean,
      default: false,
    },
    // 占位符
    placeholder: {
      type: String,
      default: '',
    },
    checkStrictly: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      options: city,
    };
  },
  methods: {
    change(e) {
      this.$store.commit(`${this.storeModelName}/updateValueFromIndex`, {
        index: this.index,
        value: e,
      });
      if (e.length == 0) {
        this.$store.dispatch(`${this.storeModelName}/getList`);
      }
    },
    handclear() {
      this.value = [];
      this.$store.commit(`${this.storeModelName}/updateValueFromIndex`, {
        index: this.index,
        value: [],
      });
    },
  },
};
</script>
